const DEFAULT_EASE = 'easeNone';

const Null = {
  type: 'enter',
  keyframes: []
};

export default Null;
